// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"un-z","badgeLink":"vn-z","category":"wn-z"};